import { Controller } from "stimulus";

export default class extends Controller {

  connect() { }

  increment(e) {
    e.preventDefault();
    let reference = e.target.dataset.reference
    if (!reference) return

    const inputs = document.querySelectorAll(`[id^="${reference}"]`)
    for (let i = 0; i < inputs.length; i++) {
      this.fillItem(inputs[i], i)
    }
  }

  fillItem(input, i) {
    const currentValue = input.value
    let intValue = 0
    const startId = this.getStartId()
    if (startId) {
      intValue = intValue + (startId)
      input.value = currentValue + (intValue + i)
    } else {
      input.value = currentValue + (intValue + 1 + i)
    }
  }

  getStartId() {
    const startIdElement = document.getElementById('start_increment_id')
    let startId = ""
    if (startIdElement) startId = parseInt(startIdElement.value)
    return startId
  }

}
